import { DATA_PRODUCT_SUBSCRIPTIONS_ENDPOINT } from '~/support/constants';

import ApiBase from './ApiBase';

export const DUPLICATE_NAMES_ENDPOINT = 'data-products/duplicate-names';
export const DESTINATIONS = 'destinations';

export default class OrgsService extends ApiBase {
  async create(body) {
    const { data } = await this.client.post('', body);

    return data;
  }

  async createDestination({ connection, orgId }) {
    const { data } = await this.client.post(`${orgId}/${DESTINATIONS}`, { connection });

    return data;
  }

  async createEntitlements(body) {
    const { data } = await this.client.post(`${body.orgId}/entitlements/bulk`, body);

    return data;
  }

  async createImage(body, orgId, params) {
    const { data } = await this.client.post(`${orgId}/image`, body, { params });

    return data;
  }

  async deactivate(orgId) {
    const { data } = await this.client.put(`${orgId}/deactivate`);

    return data;
  }

  async fetchAll({ filters } = {}) {
    const { data } = await this.client.get('', { params: { filters } });

    return data;
  }

  async fetchAllStats() {
    const { data } = await this.client.get('all/stats');

    return data;
  }

  async fetchDataProductSubscriptions(orgId) {
    const { data } = await this.client.get(`${orgId}/${DATA_PRODUCT_SUBSCRIPTIONS_ENDPOINT}`);

    return data;
  }

  async fetchDestinations({ orgId, pageSize, pageToken }) {
    const { data } = await this.client.get(`${orgId}/${DESTINATIONS}`, {
      params: {
        pageSize,
        pageToken,
      },
    });

    return data;
  }

  async fetchOne(orgId) {
    const { data } = await this.client.get(orgId);

    return data;
  }

  async fetchStatsByOrg(orgId) {
    const { data } = await this.client.get(`${orgId}/stats`);

    return data;
  }

  async fetchStatsForOwnOrg() {
    const { data } = await this.client.get('me/stats');

    return data;
  }

  async fetchUsers(orgId) {
    const { data } = await this.client.get(`${orgId}/users`);

    return data;
  }

  async fetchDuplicateDataProductNames({ dataProductNames, orgId }) {
    const { data } = await this.client.post(`${orgId}/${DUPLICATE_NAMES_ENDPOINT}`, {
      dataProductNames,
    });

    return data;
  }

  async inviteUser(orgId, user) {
    const { data } = await this.client.post(`${orgId}/users`, user);

    return data;
  }

  async update(orgId, body) {
    const { data } = await this.client.put(orgId, body);

    return data;
  }

  async updateImage(body, orgId, params) {
    const { data } = await this.client.put(`${orgId}/image`, body, { params });

    return data;
  }

  async updateSupplier(orgId, body) {
    const { data } = await this.client.put(`${orgId}/supplier`, body);

    return data;
  }

  async updateUser(orgId, userId, body) {
    const { data } = await this.client.put(`${orgId}/users/${userId}`, body);

    return data;
  }
}
